<breadcrumb endText="Assignees" [navigations]="breadcrumbNavs" />
<div class="p-2 lg:pb-2 lg:m-5">
  <div>
    <h1 class="font-semibold text-xl">
      Assignees: {{title}}
    </h1>
  </div>
  <table class="mt-4 w-full table-fixed">
    <thead class="bg-[#F4F6F8]">
      <tr class="h-[48px] text-left text-gray-500 text-xs font-semibold uppercase leading-tight">
        <th class="w-2/3 px-[16px] rounded-l-[4px]">Assignee's Name</th>
        <th class="w-1/3 px-[16px] rounded-r-[4px]">Date Assigned</th>
      </tr>
    </thead>
    <tbody>
      @for (user of users; track user) {
      <tr class="h-[60px] text-sm">
        <td class="px-[16px] text-black/90">{{user.display_name}}</td>
        <td class="px-[16px] text-gray-500">{{user.date | date:'MM/dd/y'}}</td>
      </tr>
      }
      @if (users == null || users.length === 0) {
      <tr>
        <td colspan="2" class="pt-2 text-center">No Assignees To Show</td>
      </tr>
      }
    </tbody>
  </table>
</div>